import vipCallback from './vip-callback';
import dropdownCallback from './dropdown-callback';

function observeVip() {
    var targetNode = document.body;
    var config = { childList: true };	
    var observer = new MutationObserver( vipCallback );
    observer.observe( targetNode, config );
}

function observeDropdown() {
    var targetNode = document.querySelector('.uninav');
    if(targetNode) {
        var config = { attributes: true };	
        var observer = new MutationObserver( dropdownCallback );
        observer.observe( targetNode, config );
    }
}



window.onresize = () => {
    const suggestPanel = document.getElementById('suggestPanel');
    if(suggestPanel) {
        suggestPanel.style.display = 'none';
    }
};

observeVip();
observeDropdown();

if(PCH.uninav) {
    PCH.uninav.controller.searchContinueRegistration = function(){

        try {
            var salutations = PCHUSER.firstName.length > 0?('<span class=\'body-welcome\'>Hi <strong>'+PCHUSER.firstName+'</strong>!</span>'):'<span class=\'body-welcome\'>Congratulations!</span>';
            PCH.SsoLightbox.open( {
                titleText: 'Complete Your Registration',
                bodyCopy: '<p>'+salutations+'</span> ' +
                '<br/><br/>You\'re just one step away from completing your registration and scoring ' +
                '<b>1,000 TOKENS</b> to use toward EXTRA prize opportunities in our Redemption Center.' +
                '<br/><br/>To Register NOW, click below...<br /></p>',
                button: { type: 'continue', callBack: function( e ) {
                    window.location.href = PCH.MiniRegURL;
                } },
                onClose : function(){
                    PCH.SsoLightbox.close();
                    //PCHGA.trackEvent('SSO', 'cancel', 'CreatePassword_completeRegistration'); //TODO: What event should I track, if any
                },
                policy: PCHSSOLightbox.getPolicyLink()
            } );

        } catch( e ) {
            console.log( e );
        }
    };

}


